import { Type } from 'class-transformer';
import { Model } from './model';
import { TaskTypeIconMap, TaskTypeIconClassMap, TaskTypeTransformMap, TaskType } from './task';

export enum ExpectedActionType {
  ACKNOWLEDGE = 'acknowledge',
  COMPLETE = 'complete',
  COMPLETE_WITH_ACTION = 'complete_with_action',
}

export const SubCollectionKeyMap = {
  task_type: 'classification',
  auto_response_email: 'classification',
  payment_promise: 'expected_action',
  disable_contact: 'expected_action',
  [TaskType.DisputeActivate]: 'partner',
  [TaskType.DisputeCreate]: 'partner',
  [TaskType.DisputeUpdate]: 'partner',
  call_analysis: 'classification',
};

export class TaskCollection extends Model {
  id: string;

  collection_type: string;

  name: string;

  task_count: number;

  subcollections: string[];

  get taskType(): string {
    return (TaskTypeTransformMap[this.collection_type] as string) || this.collection_type;
  }

  get showSubCollections(): boolean {
    return Boolean(
      this.subcollections.length &&
      [
        'auto_response_email',
        'call_analysis',
        'payment_promise',
        'disable_contact',
        TaskType.DisputeActivate,
        TaskType.DisputeCreate,
        TaskType.DisputeUpdate,
      ].includes(this.id),
    );
  }

  get subCollectionKey(): string | undefined {
    if (!this.showSubCollections) return undefined;

    return (SubCollectionKeyMap[this.collection_type] as string) || 'classification';
  }

  get expectedAction(): ExpectedActionType | undefined {
    if (this.collection_type === 'expected_action') {
      const id = (this.id || '').toUpperCase();
      return ExpectedActionType[id] as ExpectedActionType;
    }

    return undefined;
  }

  get isExpectsAcknowledge(): boolean {
    return this.expectedAction === ExpectedActionType.ACKNOWLEDGE;
  }
}
